import React, { Component, Children } from "react";
import "react-quill/dist/quill.snow.css";
import PropTypes from "prop-types";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Label,
  Input,
  UncontrolledTooltip
} from "reactstrap";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import Services from "./Services";
import CustomTooltip from '../../../components/Tooltip/CustomTooltip';
import getTooltip from '../JegyertekesitesTooltips';
import Wysiwyg from "../../../components/Wysiwyg/Wysiwyg";
import ToolbarBase from "../../../components/Wysiwyg/toolbar/ToolbarBase";
import ToolbarPlaceholderRow from "../../../components/Wysiwyg/toolbar/ToolbarPlaceholderRow";
import ToolbarRow from "../../../components/Wysiwyg/toolbar/ToolbarRow";
import { parseEditorImage } from "../../../commons/utils";

const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
};

const grid = 9;

const getListStyle = isDraggingOver => ({
  display: "flex",
  padding: grid,
  overflowX: "auto",
  whiteSpace: "nowrap",
  alignItems: 'center',
});

const getItemStyle = (isDragging, draggableStyle) => ({
  // some basic styles to make the items look a bit nicer
  userSelect: "none",
  padding: grid * 2,
  margin: `0 ${grid}px 0 0`,
  border: "1px",
  // styles we need to apply on draggables
  ...draggableStyle
});

class EmailSablonContent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      checked: false,
      toolbargroupjegy: [],
      toolbargroup: [],
      items: [],
      modalOpen: false,
      value: '',
      text: "",
      // ['FOG_SUCC', 'VAS_SUCC', 'FOG_DEL', 'VAS_DEL', 'VAS_FAIL']
      modalType: "",
      formTargy: "",
      emailsablontypes: [],
      emailsablonvariables: {},
      sablonok: [],
      selectedSablon: {
        caption: undefined,
        name: undefined
      },
      currentSablon: {
        id: undefined,
        targy: "",
        tartalom: "",
        tipus: {
          caption: undefined,
          name: undefined
        },
        valtozok: []
      },
      selectedJegy: []
    };
  }

  componentDidMount() {
    // this.renderJegyLista();
  }

  hasRole = (roles, checkKarb) => {
    return this.props.globals.hasRole(roles, checkKarb);
  }

  onDragEnd = result => {
    // dropped outside the list

    if (result.destination) {
      const items = reorder(
        this.state.toolbargroupjegy,
        result.source.index,
        result.destination.index
      );

      this.setState({
        toolbargroupjegy: items
      });
    } else {
      return;
    }
  };
  renderJegyLista = () => {
    const toolbarGroups = Object.entries(this.state.emailsablonvariables);
    const selected = JSON.parse(JSON.stringify(this.state.selectedJegy));
    toolbarGroups.forEach(toolbargroup => {
      let selectable = this.getSelectableByName(toolbargroup[0]);
      switch (selectable) {
        case true:
          let selectedJegy = [];
          toolbargroup[1].forEach(item => {
            selectedJegy.push({
              name: item.nam,
              checked: false
            });
          });
          this.setState({
            toolbargroupjegy: toolbargroup[1],
            selectedJegy: selectedJegy
          });
          break;

        default:
          break;
      }
    });
  };

  renderToolbarJegy = () => {
    const toolbarGroups = Object.entries(this.state.emailsablonvariables);

    return toolbarGroups.map(toolbargroup => {
      let selectable = this.getSelectableByName(toolbargroup[0]);
      let iconName = this.getIconByName(toolbargroup[0]);
      return (
        selectable && (
          <DragDropContext
            onDragEnd={this.onDragEnd}
            key="3233"
            // className={"ow-wysiwyg-toolbar-group"}
          >
            <Droppable
              droppableId="droppable"
              key="464546456486632"
              direction="horizontal"
            >
              {(provided, snapshot) => {
                return (
                  <div
                    ref={provided.innerRef}
                    style={getListStyle(snapshot.isDraggingOver)}
                    {...provided.droppableProps}
                    {...provided.droppablePlaceholder}
                  >
                    <div style={{ display: "" }}>
                      <Label>Jegyadatok:</Label>
                    </div>
                    {this.state.toolbargroupjegy.map((toolbaritem, index) => {
                      return (
                        <Draggable
                          draggableId={toolbaritem.caption}
                          index={index}
                          key={toolbaritem.nam}
                        >
                          {(provided, snapshot) => {
                            return (
                              <div
                                ref={provided.innerRef}
                                {...provided.draggableProps}
                                {...provided.dragHandleProps}
                                style={getItemStyle(
                                  snapshot.isDragging,
                                  provided.draggableProps.style
                                )}
                                key={toolbaritem.nam}
                                // className={"ow-wysiwyg-toolbar-item"}
                              >
                                <span
                                  type="text"
                                  name="text"
                                  tag={""}
                                  key={toolbaritem.caption}
                                >
                                  <span
                                    id={toolbaritem.code.substring(
                                      2,
                                      toolbaritem.code.length - 1
                                    )}
                                    style={{ width: "100%", height: "100%" }}
                                  >
                                    <i className={iconName} aria-hidden="true" />
                                    &nbsp;&nbsp;{toolbaritem.caption}
                                  </span>
                                </span>
                                <br />
                                <input
                                  name={"checked"}
                                  type="checkbox"
                                  style={{ position: "inherit" }}
                                  onChange={e => {
                                    this.handleCheckedInputChange(
                                      e,
                                      toolbaritem.nam
                                    );
                                  }}
                                  checked={this.isCheckedByName(
                                    toolbaritem.nam
                                  )}
                                />
                              </div>
                            );
                          }}
                        </Draggable>
                      );
                    })}
                    {provided.placeholder}
                  </div>
                );
              }}
            </Droppable>
          </DragDropContext>
        )
      );
    });
  };

  getIconByName = name => {
    let result = "";
    this.state.emailsablontypes.forEach(item => {
      if (item.name === name) {
        result = item.icon;
      }
    });
    return result;
  };

  getSelectableByName = name => {
    let result = false;
    this.state.emailsablontypes.forEach(item => {
      if (item.name === name) {
        result = item.selectable;
      }
    });
    return result;
  };

  renderToolbarGroups = () => {
    const toolbarGroups = Object.entries(this.state.emailsablonvariables);

    return toolbarGroups.map((toolbargroup) => {
      const selectable = this.getSelectableByName(toolbargroup[0]);
      const iconName = this.getIconByName(toolbargroup[0]);

      return !selectable && (
        <ToolbarPlaceholderRow key={iconName} icon={<i className={iconName} aria-hidden="true" />} items={toolbargroup[1]} />
      );
    });
  };

  onChange = ({ value }) => {
    this.setState({ value: value });
  };

  listSablonok = () => {
    this.setState(
      {
        tableStatus: "LOAD"
      },
      () => {
        Services.listSablonok((err, res) => {
          if (!err) {
            this.setState({
              tableStatus: res[0].length > 0 ? "TABL" : "DATA",
              sablonok: res[0]
            });
          } else {
            this.setState({
              tableStatus: "NETW"
            });
          }
        });
      }
    );
  };

  getEmailInit = (callback) => {
    Services.getEmailInit((err, res) => {
      if (!err) {
        this.setState({
          emailsablontypes: res[0].emailsablontypes,
          emailsablonvariables: res[0].emailsablonvariables
        }, () => {
          this.renderJegyLista();
          callback?.();
        });
      } else
        return;
    });
  };

  handleInputChange = e => {
    const { target } = e;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const { name } = target;
    this.setState({
      [name]: value
    });
  };

  handleCheckedInputChange = (e, name) => {
    let newJegy = [];

    this.state.selectedJegy.forEach(jegy => {
      if (jegy.name === name) {
        newJegy.push({
          name: jegy.name,
          checked: !jegy.checked
        });
      } else {
        newJegy.push({
          name: jegy.name,
          checked: jegy.checked
        });
      }
    });
    this.setState({
      selectedJegy: newJegy
    });
  };

  isCheckedByName = name => {
    let result = false;
    this.state.selectedJegy.forEach(jegy => {
      if (jegy.name === name) {
        result = jegy.checked;
      }
    });
    return result;
  };

  componentDidMount() {
    this.listSablonok();
  }

  toggle = () => {
    this.setState(prevState => ({
      modalOpen: !prevState.modalOpen
    }));
  };

  handleChange = value => {
    this.setState({ text: value });
  };

  renderSablonok = () => {
    return this.state.sablonok.map(item => {
      return (
        <div className="col-sm-12 col-md-6 col-lg-3" key={item.name}>
          <div
            style={{ minHeight: '120px' }}
            className="card card-template"
            onClick={() => {
              this.getEmailInit(() => {
                this.setState(
                  {
                    selectedSablon: item
                  },
                  () => {
                    Services.getSablon(item.name, (err, res) => {
                      if (!err) {
                        let toolbargroupjegy = [];
  
                        res[0].valtozok && res[0].valtozok.forEach(valtozo => {
                          toolbargroupjegy.push(valtozo.valtozo);
                        });
  
                        let toolbargroupjegyResult = toolbargroupjegy;
                        this.state.toolbargroupjegy.forEach(jegy => {
                          let isContained = false;
                          toolbargroupjegy.forEach(item => {
                            if (item.nam === jegy.nam) isContained = true;
                          });
                          if (!isContained) toolbargroupjegyResult.push(jegy);
                        });
                        
                        let checkedJegy = [];
                        toolbargroupjegyResult.forEach((jegy) => {
                          let isChecked = false;
                          res[0].valtozok.forEach((valtozo) => {
                            if(valtozo.valtozo.nam === jegy.nam) {
                              isChecked = true;                       
                            }
                          })
                          if(isChecked){ 
                            checkedJegy.push({
                              name: jegy.nam,
                              checked: true
                            })
                          } else {
                            checkedJegy.push({
                              name: jegy.nam,
                              checked: false
                            })
                          }
                        });
                        this.setState(
                          {
                            toolbargroupjegy: toolbargroupjegyResult,
                            currentSablon: res[0],
                            value: res[0].tartalom,
                            formTargy: res[0].targy,
                            selectedJegy: checkedJegy
                          },
                          () => {
                            this.toggle();
                          }
                        );
                      }
                    });
                  }
                );
              });
            }}
          >
            <i className="fa fa-list-alt" style={{ fontSize: 30 }} />
            <div>{item.caption}</div>
          </div>
        </div>
      );
    });
  };

  listImages = (callback) => {
    Services.listEditorImages((err,res) => {
      if(!err){
        callback(typeof res === "object" ? res[0] : []);
      }
    });
  }

  addImage = async (file) => {
    const { url } = await parseEditorImage((cb) => Services.uploadWysiwygImage(file, this.state.currentId, cb));
    return url;
  }

  render() {
    let cardStyle = {
      padding: 10
    };

    return (
      <div>
      <div className="animated fadeIn">
        <div className="card">
          <div className="card-header">
            Email sablonok
            <CustomTooltip text={getTooltip('emailsablonok')} id="emailsablonokTT" />
            {/* <YouTube data={videoData} /> */}
          </div>
          <div style={cardStyle}>
            <div className="col-md-12">
        <div className="row">{this.renderSablonok()}</div>
        <Modal
          isOpen={this.state.modalOpen}
          toggle={this.toggle}
          className={this.props.className}
          backdrop="static"
          size="lg"
          style={{ transform: "none" }}
        >
          <ModalHeader>{this.state.selectedSablon.caption}</ModalHeader>
          <ModalBody>
            <Label for="formTargy">Tárgy: *</Label>
            <Input
              type="text"
              name="formTargy"
              id="formTargy"
              value={this.state.formTargy}
              style={{ marginBottom: '16px' }}
              onChange={this.handleInputChange}
            />

            <Label>Tartalom: *</Label>
            <Wysiwyg
              value={this.state.value}
              onChange={(value) => this.onChange({ value })}
              onImageUpload={this.addImage}
              toolbar={() => 
                <>
                  <ToolbarRow style={{ padding: 0 }}>
                    {this.renderToolbarJegy()}
                  </ToolbarRow>
                  <ToolbarBase />
                  {this.renderToolbarGroups()}
                </>
              }
            />
          </ModalBody>
          <ModalFooter>
            {this.hasRole(["JEGYVASARLAS_EMAILSABLON"], true) && (
              <Button
                color="primary"
                onClick={() => {
                  let valtozok = [];
                  this.state.toolbargroupjegy.forEach((jegy) => {
                    this.state.selectedJegy.forEach((selected) => {
                      if (selected.name === jegy.nam && selected.checked) {
                        valtozok.push(selected.name);
                      }
                    });
                  });
                  Services.editSablon(
                    {
                      tipus: this.state.selectedSablon.name,
                      tartalom: this.state.value,
                      valtozok: valtozok,
                      targy: this.state.formTargy
                    },
                    (err, res) => {
                      if (!err) {
                        this.toggle();
                      }
                    }
                  );
                }}
              >
                Mentés
              </Button>
            )}{" "}
            <Button style={{ backgroundColor: "white" }} onClick={this.toggle}>
              Mégsem
            </Button>
          </ModalFooter>
        </Modal>
      </div>
      </div>
      </div>
      </div>
      </div>
    );
  }
}

EmailSablonContent.propTypes = {
  active: PropTypes.bool,
  globals: PropTypes.object
};

export default EmailSablonContent;
